var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FlatActionButton',{class:['btnTransparent', 'btnWithoutShadow', 'btnTextLink'],attrs:{"action":() => _vm.handleClick(_vm.item)}},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }